















































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import {
  ICustomStylingClass,
  ICustomProductTypes,
} from "./Globals/types/custom.t";
import type { IUGCImageErrorModal } from "./Globals/types/ugc.t";
import CustomText from "./Globals/CustomText.vue";
import CustomContainer from "./Globals/CustomContainer.vue";
import CustomImage from "./Globals/CustomImage.vue";
import CustomModal from "@/components/Modals/wrapper/modalWrapper.vue";
import ModalHeader from "@/components/molecule.modal.header.vue";
import CustomSvgIcon from "./Globals/CustomSvgIcon.vue";

@Component({
  components: {
    CustomContainer,
    CustomText,
    CustomImage,
    CustomModal,
    ModalHeader,
    CustomSvgIcon,
  },
  name: "UgcImageError",
})
export default class UgcImageError extends Vue {
  public productTypes = ICustomProductTypes;

  @Prop()
  customClass?: ICustomStylingClass[];

  @Prop()
  requirements?: IUGCImageErrorModal;

  public imageRequirements: IUGCImageErrorModal = {};

  get assetsPath() {
    return (
      this.$store.state.endPoints.customizer.customsAssets ||
      this.$store.state.endPoints.ugcentrypoint.customsAssets
    );
  }

  get translations() {
    return (
      this.$store.state.translations?.data?.modals?.ugcImageErrorModal || {}
    );
  }

  get productType() {
    return (
      this.$store.state.utils?.pdm?.product_type ||
      this.$store.state.UGCEntryPoint.productType
    );
  }

  beforeMount() {
    this.imageRequirements = this.requirements || {};
  }
}
